import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "rupee",
    standalone: true
})
export class RupeePipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}
    transform(value): unknown {
        // check if there is decimal place in the value
        const precision = value % 1 !== 0 ? '0.2' : '0.0';
        return this.currencyPipe.transform(value, 'INR', 'symbol-narrow', precision);
    }
}
